<script setup>
const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  label: {
    type: [Object, String],
    required: true,
    default: () => 'LoginLogoutButtonTemplateLabel',
  },
  v2Link: {
    type: Boolean,
  },
})

const { isWidget } = useWidgetSettings()

const buttonTheme = isWidget
  ? 'transition btn-outline-[--theme-color-nav-text] text-[--theme-color-nav-text] hover:(btn-fill-[--theme-color-accent] text-[--theme-color-accent-contrast]) [&>[data-ds-component=test]]:(transition text-[--theme-color-nav-text] hover:text-[--theme-color-accent-contrast])'
  : 'btn-outline-secondary'
</script>

<template>
  <BaseLink
    class="btn-xs w-fit flex flex-row items-center flex-gap-x-2 uppercase"
    :class="buttonTheme"
    :url
    :v2-link
  >
    <DSIcon :icon />
    <div>{{ label }}</div>
  </BaseLink>
</template>
